import { getSession, supabase } from '@app-studio-web/ui/helpers/supabase'
import * as Sentry from '@sentry/react'
import { getAllAnswers } from '../utils/onboardingStorage'

export async function saveOnboardingAnswers() {
  try {
    // Get user data
    const { data: sessionData } = await getSession()

    const userId = sessionData?.session?.user?.id

    if (!userId) {
      return { success: false }
    }

    // Get onboarding answers using the utility
    const onboardingAnswers = getAllAnswers()

    if (!Object.keys(onboardingAnswers).length) {
      return { success: false }
    }

    // Save to Supabase
    const { error } = await supabase
      .schema('pillowpath')
      .from('onboarding_answers')
      .upsert({
        user_id: userId,
        answers: onboardingAnswers,
        created_at: new Date().toISOString(),
      })

    if (error) {
      Sentry.captureException(error)
      return { success: false }
    }

    return { success: true }
  } catch (error) {
    Sentry.captureException(error)
    return { success: false }
  }
}
